import { TimeResolution, TrendingProperties } from '@vi-iot/client';

export interface TrendingData {
  devices: {
    deviceId: string;
    boilerSerial: string;
    deviceType: string;
    shortDeviceName: string;
  }[];
  enum_properties?: TrendingEnumMappedProperties;
  gateway_id: string;
  point_interval: number;
  point_start: number;
  resolution?: TimeResolution;
  series: TrendingDataSeries[];
}

export type TrendingEnumMappedProperties = {
  [key in TrendingProperties]: { [key: number]: string };
};

export interface TrendingDataSeries {
  feature: string;
  boilerSerialFeature: string;
  data: number[];
  deviceId: string;
  boilerSerial: string;
  deviceType: string;
  shortDeviceName: string;
}

export interface ChartSelectedProperties {
  chartName: string;
  features: string[];
}

export enum TrendingDateseriesError {
  NoDataWithinRange,
  ErrorDataNotFound502,
  ErrorBigDataError400,
  ErrorConnectionTimeout504,
  Default,
}

export enum TrendingDataseriesErrorType {
  DataNotFound = 'DATA_NOT_FOUND',
  BigDataError = 'BIG_DATA_ERROR',
  ConnectionTimeout = 'CONNECTION_TIMEOUT',
}

export interface TrendingItem {
  feature: string;
  label: string;
  visible: boolean;
  unit?: string;
  max?: number;
  step?: boolean;
}

export enum TrendingChartType {
  Line = 'line',
  Spline = 'spline',
  Column = 'column',
  XRange = 'xrange',
}

export enum TrendingResolution {
  Minute = '1m',
  FiveMinutes = '5m',
  Hour = '1h',
  Day = '1d',
}

export enum TrendingFeatures {
  FourWayCircuitValves = 'heating.primaryCircuit.valves.fourWay/state',
}

export enum TrendingTypeEnum {
  HEATING = 'heating',
  ENERGY_STORAGE = 'energyStorage',
}

export type TrendingType = TrendingTypeEnum.HEATING | TrendingTypeEnum.ENERGY_STORAGE;

export interface TrendingTab {
  name: string;
  type: TrendingType;
  isActive: boolean;
  isShow: boolean;
}

export interface EnergyStorageTrendingLabel {
  powerTrendingChartsLabel: TrendingItem[];
  stateOfChargeLabel: TrendingItem[];
  temperaturesLabel: TrendingItem[];
  batteryModuleVoltageLabel: TrendingItem[];
}
